// components/ChampMotDePasse.jsx
// Champ mot de passe avec bouton « Afficher / Masquer ». Masqué par défaut (état local : toujours
// masqué à l'ouverture de la page). Reçoit les mêmes propriétés qu'un <input> (id, value, onChange...).

import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Eye, EyeOff } from 'lucide-react';
import './ChampMotDePasse.css';

export default function ChampMotDePasse(props) {
  const { t } = useTranslation();
  const [visible, setVisible] = useState(false);

  return (
    <div className="champ-mdp">
      <input {...props} type={visible ? 'text' : 'password'} />
      <button
        type="button"
        className="champ-mdp-oeil"
        onClick={() => setVisible((v) => !v)}
        aria-pressed={visible}
        aria-label={t('auth.afficherMasquerMotDePasse')}
        title={t('auth.afficherMasquerMotDePasse')}
      >
        {visible ? <EyeOff size={18} aria-hidden="true" /> : <Eye size={18} aria-hidden="true" />}
      </button>
    </div>
  );
}
